import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function MainRoutesLegendIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15479_117268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 11H0V21H32V11Z",
    fill: "#F4BFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 16H48",
    stroke: "white",
    strokeDasharray: "4 4",
    strokeWidth: "2"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15479_117268"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: "32",
    width: "32"
  }))));
}